import { getTHERMSImageThumbnailUrl } from "../../../Files/utils/get-therms-image-thumbnail-url.js";
import { AppShellViewModel } from "../../viewmodels/AppShellViewModel.js";
import { SidePanelViewModel } from "../../viewmodels/SidePanelViewModel.js";
import logoIso_default from "../../../../assets/Images/logoIso.png.js";
import { AppPicker } from "./components/AppPicker.js";
import { OrgInfo } from "./components/OrgInfo.js";
import { StatusPill } from "./components/StatusPill.js";
import { navBackground } from "./nav-background.js";
import "react";
import { Avatar, Button, ButtonGroup, Icon, Image } from "@therms/atalaya";
import { IoClose } from "react-icons/io5";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { useSingleton } from "mvc-kit/react";
import { MdPushPin } from "react-icons/md";
//#region src/modules/AppWrapper2/components/AppNav/AppNavDesktop.tsx
function AppNavDesktop() {
	const shellVM = useSingleton(AppShellViewModel);
	const panelVM = useSingleton(SidePanelViewModel);
	const user = shellVM.user;
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface-strong relative flex w-full items-center",
		style: navBackground(shellVM.currentApp?.color),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "gap-x-base px-base py-xs inline-flex grow items-center",
				children: [
					/* @__PURE__ */ jsx(Image, {
						src: logoIso_default,
						fit: "cover",
						className: "w-xl shrink-0",
						lazy: false
					}),
					/* @__PURE__ */ jsx("div", { className: "border-border h-lg border-r" }),
					shellVM.appList.length > 1 && /* @__PURE__ */ jsx(AppPicker, {}),
					shellVM.organization && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", { className: "border-border h-lg border-r" }), /* @__PURE__ */ jsx(OrgInfo, {})] })
				]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "gap-x-sm px-base py-xs inline-flex items-center",
				children: [
					/* @__PURE__ */ jsx(StatusPill, {}),
					/* @__PURE__ */ jsx("div", { className: "border-border h-lg border-r" }),
					/* @__PURE__ */ jsx(Avatar, {
						circular: true,
						onClick: () => panelVM.openTo("user"),
						size: "xxs",
						statusColor: user?.status?.color,
						url: getTHERMSImageThumbnailUrl(user?.avatarUrl)
					})
				]
			}),
			panelVM.state.isOpen && panelVM.state.isPinned && /* @__PURE__ */ jsx("div", {
				className: "gap-x-base bg-surface-subtle px-base inline-flex items-center self-stretch",
				children: /* @__PURE__ */ jsxs(ButtonGroup, {
					subtle: true,
					children: [/* @__PURE__ */ jsx(Button, {
						onClick: panelVM.unPin,
						active: true,
						size: "xs",
						children: /* @__PURE__ */ jsx(Icon, {
							Icon: MdPushPin,
							size: "sm"
						})
					}), /* @__PURE__ */ jsx(Button, {
						onClick: panelVM.close,
						size: "xs",
						children: /* @__PURE__ */ jsx(Icon, {
							Icon: IoClose,
							size: "sm"
						})
					})]
				})
			})
		]
	});
}
//#endregion
export { AppNavDesktop };

//# sourceMappingURL=AppNavDesktop.js.map